export enum WizardPage_Enum {
	'FinanceDetails' = 1,
	'DrivingLicense',
	'AmountToFinance',
	'DateOfBirth',
	'AddressHistory',
	'EmploymentHistory',
	'MaritalStatus',
	'ContactDetails',
	'Summary'
}
